import React from "react";
import { Typography } from "@material-ui/core";
import TreeView from "@material-ui/lab/TreeView";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import BookmarkIcon from '@material-ui/icons/Bookmark';
import TreeItem from "@material-ui/lab/TreeItem";
import { makeStyles } from "@material-ui/core/styles";
import { getLocalizedString } from "@icarius-localization/strings";
import ActivityTypeIcon from "@icarius-pages/myTraining/components/trainingExecution/sidebar/activitySelection/activityTypeIcon";

const useStyles = makeStyles({
    labelRoot: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        minHeight: 28,
    },
});

const CourseTree = ({ data }) => {

    const classes = useStyles();

    return (
        <TreeView
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            defaultExpanded={["root"]}
        >
            <TreeItem
                nodeId={"root"}
                label={
                    <div className={classes.labelRoot}>
                        <MenuBookIcon />
                        <Typography variant="body2" >
                            {data.name}
                        </Typography>
                    </div>
                }
            >
                {
                    data.modules?.map((module, indexModule) => {
                        return (
                            <TreeItem
                                key={`module-${module.id}-${indexModule}`}
                                nodeId={`module-${module.id}-${indexModule}`}
                                label={
                                    <div className={classes.labelRoot}>
                                        <BookmarkIcon />
                                        <Typography variant="body2">
                                            {`${getLocalizedString("module")}: ${module.name}`}
                                        </Typography>
                                    </div>
                                }
                            >
                                {
                                    module.activities?.map((activity, indexActivity) => {
                                        return (
                                            <TreeItem
                                                key={`activity-${activity.id}-${indexActivity}`}
                                                nodeId={`activity-${activity.id}-${indexActivity}`}
                                                label={
                                                    <div className={classes.labelRoot}>
                                                        <ActivityTypeIcon
                                                            type={activity.type}
                                                            title={activity.typeString}
                                                        />
                                                        <Typography variant="body2">
                                                            {activity.name}
                                                        </Typography>
                                                    </div>
                                                }
                                            />
                                        )
                                    })
                                }
                            </TreeItem>
                        )
                    })
                }
            </TreeItem>
        </TreeView>
    );
}

export default CourseTree;